import React, { useState } from "react";
import { Building2, FileText, Package, Settings, BarChart3, DollarSign, Calendar, FileCheck, Menu, X, BookOpen, Receipt, Wallet } from "lucide-react";
import NavLink from "./NavLink";

function Layout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="flex h-screen bg-slate-50">
      {/* Sidebar */}
      <aside className={`bg-white border-r border-slate-200 w-64 flex-shrink-0 ${menuOpen ? 'block' : 'hidden'} md:block`}>
        {/* Logo */}
        <div className="h-16 flex items-center justify-center border-b border-slate-200 bg-white">
          <img src="./logo-deflorencia.png" alt="Deflorencia" className="h-10" />
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-1">
          <NavLink to="/" icon={<BarChart3 className="w-4 h-4" />}>Dashboard</NavLink>
          <NavLink to="/obras" icon={<Building2 className="w-4 h-4" />}>Obras</NavLink>
          <NavLink to="/presupuestos" icon={<DollarSign className="w-4 h-4" />}>Presupuestos</NavLink>
          <NavLink to="/cotizaciones" icon={<FileCheck className="w-4 h-4" />}>Cotizaciones</NavLink>
          <NavLink to="/cronogramas" icon={<Calendar className="w-4 h-4" />}>Cronogramas</NavLink>
          <NavLink to="/gastos" icon={<Receipt className="w-4 h-4" />}>Gastos</NavLink>
          <NavLink to="/finanzas" icon={<Wallet className="w-4 h-4" />}>Finanzas</NavLink>
          <NavLink to="/certificados" icon={<FileText className="w-4 h-4" />}>Certificados</NavLink>
          <NavLink to="/catalogo" icon={<Package className="w-4 h-4" />}>Catálogo</NavLink>
          <NavLink to="/manual" icon={<BookOpen className="w-4 h-4" />}>Manual de Usuario</NavLink>
          <NavLink to="/configuracion" icon={<Settings className="w-4 h-4" />}>Configuración</NavLink>
        </nav>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header con hamburger para mobile */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center px-4 md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} className="p-2">
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
          <span className="ml-4 font-semibold text-lg">Deflorencia</span>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
